import { authAxios, publicAxios } from "../config";
import { ApiKey } from "../endpoints";

export const GetBlogsByStatus = async ({ status_id, author_id, pageNumber, pageSize }) => {
    try {
      const body = {
        author_id: author_id,
        status_id: status_id,
        PageNumber: pageNumber,
        PageSize: pageSize
      };
      const response = await authAxios.post(`${ApiKey.getblogsByStatus}`,body);

      console.log("API Response(getblogsByStatus):", response);
      console.log("Result:", response?.data?.result);
      console.log("Blog Detail:", response?.data?.result_value);

      return response;
    } catch (error) {
      console.log("Error in package details", error);
    }
  };

export const ChangeBlogVisibility = async({blog_id , is_active, user_id}) =>{
  try{
    const body = {
      blog_id: blog_id,
      is_active: is_active,
      user_id: user_id
    };
    const response = await authAxios.post(`${ApiKey.changeBlogVisibility}`,body);
    console.log("API Response (changeBlogVisibility):", response);

    return response;
  }catch(error){
    console.log("Error in package details", error);
  }
};

export const ChangeBlogStatus = async({blog_id,status_id,user_id,blog_reject_reason}) =>{
  try{
    const body = {
      blog_id: blog_id,
      status_id: status_id,
      user_id: user_id,
      blog_reject_reason: blog_reject_reason
    }
    const response = await authAxios.post(`${ApiKey.changeBlogStatus}`,body);
    console.log("API Response (changeBlogStatus):", response);

    return response;
  }catch(error){
    console.log("Error in package details", error);
  }
};